
const Courts = () => {

    return(
        <div className="error-page">
            <h1>Judges</h1>
        </div>
    )
}

export default Courts;